const padNumber = (value: number, pad: number) => {
  const maxPrefixZero = pad - 1;

  return ('0'.repeat(maxPrefixZero) + value.toFixed(0)).slice(-pad);
};

export default padNumber;
